import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 20px 20px 10px;
  width: 100%;
  min-width: 380px;

  .widget-name {
    font-size: 16px;
    text-align: center;
  }

  .widget-container {
    width: 100%;
    justify-content: space-between;
  }

  .knob {
    box-shadow: 10px 5px 5px red;
  }

  .info-cards {
    flex: 0 0 50%;
  }

  .no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 160px;
    font-size: 14px;
    color: ${(props) => props.theme.colors.text};
    opacity: 0.35;
  }

  .chart-container {
    align-self: center;
    padding: 15px 30px;
    height: 200px;

    canvas {
      margin 0 auto;
    }
  }
`;

export default { Wrapper };
